'use client';
import { DAILY_UI, STATIC_BLUR_DATA_URL } from '@/constants';
import { useViewport } from '@/hooks';
import { useMount } from '@/hooks/use-mount';
import { cx, getRandomMasonryHeroLayout } from '@/lib/utils';
import { MasonaryGridItem } from '@/types';
import { Img, Skeleton } from '../ui';
import { MasonryGrid } from './masonry-grid';
import { ViewAllBtn } from './view-all-btn';

const DESKTOP_DESIRED_ORDER = [
  [1, 0, 0, 0, 0, 1, 0, 1, 0],
  [0, 0, 1, 1, 0, 0, 0, 1, 0],
  [0, 1, 0, 1, 0, 0, 0, 0, 1],
  [0, 1, 0, 0, 0, 1, 1, 0, 0],
];

const MOBILE_DESIRED_ORDER = [
  [0, 1, 0, 1, 1, 0, 1, 0],
  [1, 0, 1, 0, 0, 1, 0, 1],
];

const getOrderAfterMount = (isMobile: boolean) =>
  getRandomMasonryHeroLayout(DAILY_UI, isMobile ? MOBILE_DESIRED_ORDER : DESKTOP_DESIRED_ORDER);

export const DailyUiList = ({ shouldPrioritize }: { shouldPrioritize?: boolean }) => {
  const { mount } = useMount();
  const { isMobile } = useViewport();

  const order: MasonaryGridItem[] | number[] = mount
    ? getOrderAfterMount(isMobile)
    : Array.from({ length: 9 }, (_, index) => index);

  return (
    <div className="border-b border-skin-line pb-10">
      <h1 className="py-[43px] uppercase text-skin-primary">Daily Ui</h1>
      <MasonryGrid>
        {order.map((item) => {
          if (typeof item === 'number') {
            const firstOrder = DESKTOP_DESIRED_ORDER[0];
            return (
              <div key={item} className="flex break-inside-avoid items-center justify-center rounded-xl shadow-img">
                <Skeleton className={cx('w-full rounded-xl', firstOrder[item] ? 'aspect-210/209' : 'aspect-105/156')} />
              </div>
            );
          }
          const { id, blurDataURL, ...rest } = item;
          return (
            <div key={id} className="flex break-inside-avoid items-center justify-center rounded-xl shadow-img">
              <Img
                {...rest}
                priority={shouldPrioritize && rest.priority}
                placeholder="blur"
                blurDataURL={blurDataURL ?? STATIC_BLUR_DATA_URL}
                className="w-full rounded-xl"
                sizes="(max-width: 768px) 50vw, 33vw"
              />
            </div>
          );
        })}
      </MasonryGrid>
      <div className="mt-10 grid place-content-center">
        <ViewAllBtn href="/daily-ui" />
      </div>
    </div>
  );
};
